import React from 'react';
import { AuthPage } from '../components';
import SignUpPageForm from './SignUpPageForm';
import { useParams } from 'react-router-dom';
import ContentCreatorApplicationPage from './ContentCreatorApplicationPage';

export default function SignUpPage() {
  const params = useParams();
  const signupAccountType = params.accountType;

  if (signupAccountType.includes('content-creator-application')) {
    return <ContentCreatorApplicationPage />;
  }

  return (
    <AuthPage
      light
      headerLink="/login"
      headerLinkLabel="Sign in"
      headerLinkDescription="Already have an account?"
    >
      <SignUpPageForm signupAccountType={signupAccountType} />
    </AuthPage>
  );
}
